import ModalCloseButton from './component.styles'
export default ModalCloseButton
